import React, { useEffect } from "react";
import { Box, Container, Typography, Button, CssBaseline, Stack, Avatar } from "@mui/material";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faStore, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

// Logo
import logo from '../../assets/images/logos/black.png';

export default function SelectUserType() {
    const history = useHistory();

    useEffect(()=>{
        window.scrollTo(0,0);
    },[]);

    const redirect = (route) => {
        history.push(route);
    };

    // Estilo unificado para los botones tipo "Tarjeta"
    const optionStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'left',
        p: 3,
        border: '2px solid #e0e0e0',
        borderRadius: 4,
        bgcolor: '#fff',
        transition: 'all 0.2s ease-in-out',
        textTransform: 'none',
        color: 'inherit',
        '&:hover': {
            borderColor: 'primary.main',
            bgcolor: 'primary.50', // Fondo azul muy clarito al pasar el mouse
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            transform: 'translateY(-3px)'
        }
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: '#ffffff', // Fondo blanco puro
            p: 3
        }}>
            <CssBaseline />
            
            <Container maxWidth="sm" disableGutters>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>

                    {/* --- LOGO --- 
                    <Box sx={{ mb: 4 }}>
                        <img src={logo} alt="QUD Logo" style={{ width: 85, height: 'auto' }} />
                    </Box>*/}

                    {/* --- TÍTULO Y SUBTÍTULO --- */}
                    <Typography variant="h4" fontWeight="800" color="#111" textAlign="center" gutterBottom sx={{ fontSize: { xs: '1.75rem', sm: '2.25rem' } }}>
                        Únete a la comunidad
                    </Typography>
                    <Typography variant="body1" color="text.secondary" textAlign="center" mb={6}>
                        Selecciona el tipo de cuenta que mejor se adapte a tus necesidades para comenzar.
                    </Typography>

                    {/* --- OPCIONES DE CUENTA (Tarjetas Interactivas) --- */}
                    <Stack spacing={3} sx={{ width: '100%', mb: 5 }}>

                        {/* Opción 1: Personal */}
                        <Button sx={[optionStyle,{'&:hover':{borderColor:'#1976d2'}}]} onClick={() => redirect('/auth/personSignUp')}>
                            <Avatar sx={{ width: 60, height: 60, bgcolor: '#e3f2fd', color: '#1976d2', mr: 3 }}>
                                <FontAwesomeIcon icon={faUser} size="lg" />
                            </Avatar>
                            <Box>
                                <Typography variant="h6" fontWeight="800" color="#222" gutterBottom sx={{ lineHeight: 1 }}>
                                    Cuenta Personal
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    Explora comercios, reserva citas y realiza compras de manera fácil y rápida.
                                </Typography>
                            </Box>
                        </Button>

                        {/* Opción 2: Comercial */}
                        <Button sx={[optionStyle,{'&:hover':{borderColor:'#673ab7'}}]} onClick={() => redirect('/auth/merchantSignUp')}>
                            <Avatar sx={{ width: 60, height: 60, bgcolor: '#ede7f6', color: '#673ab7', mr: 3 }}>
                                <FontAwesomeIcon icon={faStore} size="lg" />
                            </Avatar>
                            <Box>
                                <Typography variant="h6" fontWeight="800" color="#222" gutterBottom sx={{ lineHeight: 1 }}>
                                    Cuenta Comercial
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    Vende productos, gestiona reservas y administra tu negocio digitalmente.
                                </Typography>
                            </Box>
                        </Button>

                    </Stack>

                    {/* --- VOLVER AL LOGIN --- */}
                    <Button
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                        onClick={() => redirect('/auth/signIn')} // O la ruta que use tu login
                        sx={{ 
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            color: 'text.secondary', 
                            '&:hover': { color: 'primary.main', bgcolor: 'transparent', textDecoration: 'underline' } 
                        }}
                    >
                        Volver al inicio de sesión
                    </Button>

                </Box>
            </Container>
        </Box>
    );
}